import { gql } from '__generated__'

export const GetCompanies = gql(/* GraphQL */ `
    query GetCompanies($limit: Int, $page: Int, $name: String!) {
        companiesByName(limit: $limit, page: $page, name: $name) {
            data {
                createdAt
                updatedAt
                id
                value
                industries {
                    industry {
                        id
                        value
                    }
                    topTier
                }
                sectors {
                    sector {
                        id
                        value
                    }
                    topTier
                }
                companyFunds {
                    id
                    name
                    fundSizeMillions
                    year
                }
                headquarters {
                    officeLocation {
                        id
                        value
                    }
                }
                isActive
                nonPoachDate
                status {
                    isActive
                    status
                }
                url
                profileImageKey
            }
            pageInfo {
                pageNumber
                pageTotal
                itemTotal
            }
        }
    }
`)

export const GetIndustryOptions = gql(/* GraphQL */ `
    query GetIndustryOptions {
        industries {
            id
            value
        }
    }
`)
export const GetPreferenceIndustryOptions = gql(/* GraphQL */ `
    query GetPreferenceIndustryOptions {
        preferenceIndustries {
            id
            value
        }
    }
`)

export const GetSectorOptions = gql(/* GraphQL */ `
    query GetSectorOptions {
        sectors {
            id
            value
        }
    }
`)

export const GetPreferenceSectorOptions = gql(/* GraphQL */ `
    query GetPreferenceSectorOptions {
        preferenceSectors {
            id
            value
        }
    }
`)

export const GetFundSizeBucketOptions = gql(/* GraphQL */ `
    query GetFundSizeBucketOptions {
        fundSizeBuckets {
            id
            value
        }
    }
`)

export const GetVisaStatusOptions = gql(/* GraphQL */ `
    query GetVisaStatusOptions {
        visaStatuses {
            id
            value
        }
    }
`)

export const GetPreferenceLocationOptions = gql(/* GraphQL */ `
    query GetPreferenceLocationOptions {
        preferenceLocations {
            id
            value
        }
    }
`)

export const GetCompanyOffices = gql(/* GraphQL */ `
    query GetCompanyOffices($companyId: ID!) {
        company(id: $companyId) {
            value
            companyOffices {
                officeLocation {
                    value
                    id
                }
                isActive
                id
            }
        }
    }
`)

export const GetCompanyClientContacts = gql(/* GraphQL */ `
    query GetCompanyClientContacts($companyId: ID!) {
        company(id: $companyId) {
            employees {
                id
                user {
                    id
                    nickname
                    firstName
                    lastName
                }
            }
            clientContacts {
                group
                contactType
                candidateId
                candidate {
                    id
                    user {
                        id
                        nickname
                        firstName
                        lastName
                    }
                }
            }
        }
    }
`)

export const GetCompany = gql(/* GraphQL */ `
    query GetCompany($companyId: ID!) {
        company(id: $companyId) {
            id
            value
            companyFunds {
                id
                name
                fundSizeMillions
                year
            }
            industries {
                id
                topTier
                isPrimary
                industry {
                    id
                    value
                }
            }
            employees {
                id
                user {
                    firstName
                    lastName
                    nickname
                    id
                }
                outreachStatus {
                    status
                }
                currentWorkExperience {
                    title {
                        value
                        id
                    }
                    industries {
                        industry {
                            id
                            value
                        }
                    }
                    startDate
                }
            }
            documents {
                documentKey
                id
            }
            fundSizeBuckets {
                id
                value
            }
            headquarters {
                officeLocation {
                    id
                    value
                }
            }
            companyOffices {
                id
                officeLocation {
                    id
                    value
                }
                isHeadquarters
            }
            sectors {
                sector {
                    id
                    value
                }
                id
                topTier
            }
            url
            nonPoachDate
            profileImageKey
            status {
                status
            }
            notes {
                createdAt
                updatedAt
                id
                companyId
                isPinned
                title
                noteData
                isActive
                createdBy
                updatedBy
                createdByUser {
                    firstName
                    lastName
                }
                updatedByUser {
                    firstName
                    lastName
                }
            }
            clientContacts {
                candidateId
                candidate {
                    user {
                        firstName
                        lastName
                        nickname
                        phone
                        email
                    }
                    currentWorkExperience {
                        company {
                            value
                        }
                        industries {
                            industry {
                                id
                                value
                            }
                        }
                        companyOffice {
                            officeLocation {
                                id
                                value
                            }
                        }
                    }
                }
                group
                contactType
                id
            }
            recruiterContacts {
                id
                recruiterId
                recruiter {
                    id
                    user {
                        id
                        firstName
                        nickname
                        lastName
                    }
                }
                group
                contactType
            }
        }
    }
`)

export const GetCompanyEmployeesPaginated = gql(/* GraphQL */ `
    query GetCompanyEmployeesPaginated(
        $companyId: ID!
        $page: Int
        $limit: Int
    ) {
        employeesPaginated(companyId: $companyId, page: $page, limit: $limit) {
            pageInfo {
                itemTotal
                pageNumber
                pageTotal
            }
            data {
                id
                user {
                    firstName
                    lastName
                    nickname
                    id
                }
                outreachStatus {
                    status
                    nonPoachDate
                }
                currentWorkExperience {
                    title {
                        value
                        id
                    }
                    industries {
                        industry {
                            id
                            value
                        }
                    }
                    startDate
                }
            }
        }
    }
`)

export const DeleteCompany = gql(/* GraphQL */ `
    mutation DeleteCompany($input: DeleteCompanyInput!) {
        deleteCompany(input: $input) {
            success
            message
        }
    }
`)

export const AddCompany = gql(/* GraphQL */ `
    mutation AddCompany($input: AddCompanyInput!) {
        addCompany(input: $input) {
            id
            value
        }
    }
`)

export const UpdateCompany = gql(/* GraphQL */ `
    mutation UpdateCompany($input: UpdateCompanyInput!) {
        updateCompany(input: $input) {
            success
            message
        }
    }
`)
export const UpdateCompanyFunds = gql(/* GraphQL */ `
    mutation UpdateCompanyFunds(
        $fundInformation: [CompanyFundsEntry!]
        $companyId: ID!
    ) {
        updateCompanyFunds(
            fundInformation: $fundInformation
            companyId: $companyId
        ) {
            success
        }
    }
`)

export const UpdateCompanyClientContacts = gql(/* GraphQL */ `
    mutation UpdateCompanyClientContacts(
        $companyId: ID!
        $clientContacts: [CompanyClientContactEntry!]
    ) {
        updateCompanyClientContacts(
            companyId: $companyId
            clientContacts: $clientContacts
        ) {
            success
            message
        }
    }
`)
export const DownloadCompanyDocument = gql(/* GraphQL */ `
    query DownloadCompanyDocument($documentId: String!) {
        downloadCompanyDocument(documentId: $documentId) {
            url
        }
    }
`)

export const DeleteCompanyDocument = gql(/* GraphQL */ `
    mutation DeleteCompanyDocument($documentId: String!) {
        deleteCompanyDocument(documentId: $documentId) {
            success
            message
        }
    }
`)

export const UpdateCompanyRecruiterContacts = gql(/* GraphQL */ `
    mutation UpdateCompanyRecruiterContacts(
        $companyId: ID!
        $recruiterContacts: [CompanyRecruiterContactEntry!]
    ) {
        updateCompanyRecruiterContacts(
            companyId: $companyId
            recruiterContacts: $recruiterContacts
        ) {
            success
            message
        }
    }
`)

export const GetCompanyClients = gql(/* GraphQL */ `
    query GetCompanyClients($companyId: ID!) {
        company(id: $companyId) {
            id
            value
            adminClient {
                id
                user {
                    id
                    preferredName
                }
            }
            clients {
                id
                lastLogin
                isAdmin
                user {
                    id
                    preferredName
                    email
                }
            }
        }
    }
`)
